export default {
      id: "icon-info-usage",
      viewBox: "0 0 256 256",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#icon-info",
      toString: function () {
        return this.url;
      }
    }